import SecureRoute from './secure-route.container';

export default SecureRoute;



// WEBPACK FOOTER //
// ./src/secure-route/index.jsx